module.exports = __webpack_public_path__ + "img/logo.391f28f3.png";